import type { SilaeCredentialSchema } from '@libs/data-access/entities'
import { type QueryFnParams, httpServices } from '@libs/data-access/queries'

export type PostSilaeCredentialOption = QueryFnParams<{
  payload: {
    identifier: string
    public_key: string
    secret_key: string
    allowed_to_subscribed_addon: true
    terms_and_conditions: true
  }
}>

export const postSilaeCredential = async (opts?: PostSilaeCredentialOption) => {
  const response = await httpServices.core.post<SilaeCredentialSchema>(
    '/silae/credentials',
    opts?.payload
  )
  return response.data
}

export type PutSilaeCredentialOption = QueryFnParams<{
  payload: {
    identifier: string
    public_key: string
    secret_key: string
  }
}>

export const putSilaeCredential = async (opts?: PutSilaeCredentialOption) => {
  const response = await httpServices.core.put<SilaeCredentialSchema>(
    '/silae/credentials',
    opts?.payload
  )
  return response.data
}

export type FetchSilaeCredentialOptions = QueryFnParams<{}>

export const fetchSilaeCredential = async (
  opts?: FetchSilaeCredentialOptions
) => {
  const response = await httpServices.core.get<SilaeCredentialSchema>(
    '/silae/credentials',
    opts
  )
  return response.data
}
